"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList>
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-foreground-light hover:text-accent-dark transition-colors duration-[var(--duration-fast)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isOpen, setIsOpen] = useState(false);
  if (loading) {
    return <Button variant="ghost" size="icon" className="md:hidden">
        <Menu className="size-5" />
      </Button>;
  }
  return <>
      <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
        {isOpen ? <X className="size-5" /> : <Menu className="size-5" />}
      </Button>

      {isOpen && <div className="absolute top-full left-0 w-full bg-background border-t border-border shadow-md md:hidden">
          <nav className="flex flex-col p-4 gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-3 rounded-md text-foreground-light hover:bg-accent/10 hover:text-accent-dark transition-all duration-[var(--duration-fast)]" onClick={() => setIsOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <header ref={ref} className="w-full bg-background border-b border-border sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between gap-4">
        {}
        <Link to="/" className={`flex-shrink-0 transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1465435/img/first_class_resources_logo.png" alt="FIRST CLASS RESOURCES, LLC" className="h-7" />
        </Link>

        {}
        <div className={`flex-1 flex justify-center transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: "100ms"
      }}>
          <MenuProvider menu_id="22">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className={`hidden md:flex transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: "200ms"
      }}>
          <Button asChild className="bg-accent-dark text-foreground-accent hover:bg-accent-dark/90 hover:shadow-md hover:scale-[1.02] active:scale-100 transition-all duration-[var(--duration-fast)] focus-visible:ring-accent">
            <Link to="#">Get Started</Link>
          </Button>
        </div>

        {}
        <MenuProvider menu_id="22">
          <MobileMenuConsumer />
        </MenuProvider>
      </div>
    </header>;
}